import React from "react";
const ArrowRight = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M208 913.792l90.496 90.528 497.792-497.824-4.32-4.32 4.352-4.352L298.496 0 208 90.56l411.648 411.616L208 913.792z" />
  </svg>
);
export default ArrowRight;
